// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Link } from "@tanstack/react-router";
import { UserRound } from "lucide-react";
import { cn } from "@/lib/utils";

interface UserLinkProps {
  publicId: string;
  /** Display label — typically the user's full name or email. */
  legibleName: string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Linked user reference: leading user icon + display name, pointing to `/iam/users/$publicId`.
 * Drop-in for the per-cell `<Link>` we used to render in data tables.
 */
export function UserLink({ publicId, legibleName, className, showIcon = true }: UserLinkProps) {
  return (
    <Link
      to="/iam/users/$publicId"
      params={{ publicId }}
      className={cn("whitespace-nowrap text-primary hover:underline", className)}
    >
      {showIcon && <UserRound className="mr-1.5 inline-block size-3.5 align-[-0.15em]" aria-hidden="true" />}
      <span>{legibleName}</span>
    </Link>
  );
}
